import { useLanguage } from "../../../i18n/LanguageContext";

export default function BulletListBlock({ block }) {
  const { language } = useLanguage();

  const items = block.content?.items || [];
  const translatedItems =
    block.translated_content?.items || [];

  const getTranslatedItem = (item, index) => {
    if (language === "zh") {
      return item.chinese || null;
    }

    if (language === "es" || language === "ru") {
      return translatedItems[index] || null;
    }

    return null;
  };

  return (
    <div
      style={{
        padding: "18px",
        border: "1px solid #e5e7eb",
        borderRadius: "14px",
        marginBottom: "14px",
        backgroundColor: "#ffffff",
      }}
    >
      {block.title && (
        <h3 style={{ marginTop: 0 }}>
          {block.title}
        </h3>
      )}

      <ul
        style={{
          margin: 0,
          paddingLeft: "22px",
          display: "grid",
          gap: "12px",
        }}
      >
        {items.map((item, index) => {
          const translatedItem =
            getTranslatedItem(item, index);

          return (
            <li key={index}>
              {/* Canonical English */}
              <div>
                {item.english || ""}
              </div>

              {/* Selected-language learning aid */}
              {translatedItem && (
                <div
                  style={{
                    color: "#6b7280",
                    marginTop: "3px",
                  }}
                >
                  {translatedItem}
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}